// TODO copy: nomes dos sócios são ilustrativos, só para compor o mock da
// cláusula renderizada — não são dado de cliente nenhum.
/**
 * Trecho de contrato renderizado em HTML/CSS puro (nada de screenshot):
 * mostra o valor por extenso batendo com o algarismo — "202 (duzentas e
 * duas) quotas" — e a concordância de gênero entre "a sócia"/"o sócio" e o
 * verbo, lado a lado na mesma cláusula.
 */
export function MockClausula(): JSX.Element {
  return (
    <div className="cartao-vidro flex flex-col gap-3 p-6">
      <p className="text-auth-texto-terciario text-[0.65rem] tracking-[0.14em] uppercase">
        Contrato social · trecho renderizado
      </p>
      <div className="flex flex-col gap-2 text-sm leading-relaxed">
        <p className="text-auth-texto font-medium tracking-tight">
          CLÁUSULA QUARTA — DO CAPITAL SOCIAL
        </p>
        <p className="text-auth-texto-secundario">
          O capital social é de{' '}
          <span className="text-auth-texto font-semibold tabular-nums">
            R$ 202.000,00
          </span>{' '}
          (duzentos e dois mil reais), dividido em{' '}
          <span className="text-auth-texto font-semibold tabular-nums">202</span> (
          <span className="text-auth-marca-hover font-medium">duzentas e duas</span>)
          quotas no valor nominal de R$ 1.000,00 cada, assim distribuídas: a sócia Maria
          integraliza{' '}
          <span className="text-auth-texto font-semibold tabular-nums">101</span> (
          <span className="text-auth-marca-hover font-medium">cento e uma</span>) quotas;
          o sócio João integraliza{' '}
          <span className="text-auth-texto font-semibold tabular-nums">101</span> (
          <span className="text-auth-marca-hover font-medium">cento e uma</span>) quotas.
        </p>
      </div>
    </div>
  );
}
